import http from '../config'
const health_file_group = {
  // 群组
  getFamilyGroup() {
    return http({
      url: 'user/familyGroup'
    })
  },
  addFamilyGroup(data) {
    return http({
      url: 'user/familyGroup',
      data,
      method: 'post'
    })
  },
  editFamilyGroup(data, id) {
    return http({
      url: `user/familyGroup/${id}`,
      data,
      method: 'put'
    })
  },
  deleteFamilyGroup(id) {
    return http({
      url: `user/familyGroup/${id}`,
      method: 'delete'
    })
  },
  // 群组组员
  getGroupMember(params) {
    return http({
      url: 'user/groupMember',
      params
    })
  },
  // 获取群消息  群解散
  getGroupNotices() {
    return http({
      url: 'user/groupNotices'
    })
  },
  readGroupNotice(id) {
    return http({
      url: `user/groupNotice/read/${id}`,
      method: 'post'
    })
  },
  addGroupMember(data) {
    return http({
      url: 'user/groupMember',
      data,
      method: 'post'
    })
  },
  editGroupMember(data, id) {
    return http({
      url: `user/groupMember/${id}`,
      data,
      method: 'put'
    })
  },
  deleteGroupMember(id) {
    return http({
      url: `user/groupMember/${id}`,
      method: 'delete'
    })
  },

  // 邀请绑定
  getInviteBinds() {
    return http({
      url: 'user/inviteBinds'
    })
  },
  // 获取邀请绑定信息
  getInviteBindInfo(id) {
    return http({
      url: `user/inviteBind/${id}`
    })
  },
  // 查询邀请进度
  getInviteBindStatus(params) {
    return http({
      url: 'user/inviteBind/status',
      params
    })
  },
  inviteBind(data) {
    return http({
      url: 'user/inviteBinds',
      data,
      method: 'post'
    })
  },
  rejectBind(id) {
    return http({
      url: `user/inviteBind/reject/${id}`,
      method: 'post'
    })
  },
  agreeBind(id) {
    return http({
      url: `user/inviteBind/agree/${id}`,
      method: 'post'
    })
  },
  cancelInviteBind(id) {
    return http({
      url: `user/inviteBind/cancel/${id}`,
      method: 'post'
    })
  },
  editMemberPermission(data, id) {
    return http({
      url: `user/groupMemberPermission/edit/${id}`,
      method: 'post',
      data
    })
  },
  resendSms(data, id) {
    return http({
      url: `user/inviteBind/resendSms/${id}`,
      method: 'post',
      data
    })
  },
  checkMemberPermission(params) {
    return http({
      url: 'user/groupMemberPermission/have',
      params
    })
  },
  getBasicId() {
    return http({
      url: 'user/basicsRemark/self',
      method: 'post'
    })
  },
  editInviteMember(params) {
    return http({
      url: 'user/inviteMember/edit',
      params,
      method: 'post'
    })
  },
  switchSelectedGroup(params) {
    return http({
      url: 'user/groupChoice/set',
      params,
      method: 'post'
    })
  },
  getSelectedGroup() {
    return http({
      url: 'user/groupChoice/get',
      method: 'post'
    })
  }
}

export default health_file_group
